<div class="flex flex-col gap-2 overflow-y-hidden">
  <div class="flex max-h-[432px] flex-col gap-2 overflow-y-auto">
    @if (comments().length === 0) {
      <div class="text-gray-2">{{ "memberComments.description.empty" | translate }}</div>
    } @else {
      @for (comment of comments(); track comment.id) {
        <div class="flex items-start gap-2 rounded-lg bg-purple-100 px-2 py-1 text-purple-600">
          <div class="flex grow flex-col gap-1">
            <p>{{ comment.content }}</p>
            <p class="text-xs">{{ comment.creatorName }} · {{ comment.createdAt | date: "short" }}</p>
          </div>
          <div class="flex shrink-0 items-center gap-2 self-center">
            <mat-icon
              class="cursor-pointer text-gray-2"
              (click)="enableCommentUpdateProcess(comment)"
            >
              edit
            </mat-icon>
            <mat-icon
              class="cursor-pointer text-red-error-dark"
              (click)="deleteCommentAction(comment.id)"
            >
              delete_outline
            </mat-icon>
          </div>
        </div>
      }
    }
  </div>

  @if (updatedComment()) {
    <div class="mt-2 flex items-center gap-2 pe-2">
      <div class="grow">
        <p class="mb-1">{{ "memberComments.label.edit" | translate }}</p>
        <p>{{ updatedComment().content }}</p>
      </div>
      <mat-icon
        class="cursor-pointer text-gray-2"
        (click)="cancelCommentUpdateProcess()"
      >
        cancel
      </mat-icon>
    </div>
  }

  <form
    class="mt-2 flex h-1/6 gap-2"
    [formGroup]="commentForm"
  >
    <div class="grow">
      <mat-form-field class="no-subscript w-full">
        <mat-label>{{ "memberComments.form.label.comment" | translate }}</mat-label>
        <input
          matInput
          formControlName="text"
        />
      </mat-form-field>
    </div>
    <div class="shrink-0">
      <button
        class="btn btn-primary h-[2.25rem] px-1.5 py-1"
        [disabled]="loading() || !commentForm.controls.text.value?.trim()"
        (click)="submitCommentAction()"
      >
        <mat-icon class="text-lg">arrow_upward</mat-icon>
      </button>
    </div>
  </form>
</div>
